import React, { useState } from 'react';

import NotificationMessage from '~/components/ClaimPage/CliveApp/CliveNotifications/NotificationMessage';
import Text from '~/components/core/TextComponents/Text';
import ChevronDownIcon from '~/components/icons/ChevronDownIcon';
import ChevronUpIcon from '~/components/icons/ChevronUpIcon';
import colors from '~/theme/tailwind/colors';

import { CONVERSATION_TEXTS } from '../../../conversation/texts';

interface RunEndedProps {
  /** How the run ended, as claims-ai sent it. */
  disposition: string | null;
  /** The run's gated summary, where this card is the one to show it. */
  summary: string | null;
}

/**
 * The foot of Clive's reply: how the run ended, and the run's summary behind a toggle, closed. The reply is
 * what the handler came for; the summary is the run's account of itself, a click away. The toggle is the
 * one a card's explanation sits behind.
 */
const RunEnded: React.FC<RunEndedProps> = ({ disposition, summary }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4 border-0 border-t border-dashed border-grey-100 pt-8">
      <Text variant={Text.VARIANTS.XS} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
        {CONVERSATION_TEXTS.RUN_ENDED(disposition)}
        {summary ? (
          <>
            {CONVERSATION_TEXTS.SEPARATOR}
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => setIsOpen((open) => !open)}
              className="inline-flex cursor-pointer items-center gap-4 border-0 bg-transparent p-0 align-middle text-current [font:inherit]"
            >
              {CONVERSATION_TEXTS.SUMMARY}
              {isOpen ? (
                <ChevronUpIcon size={14} iconColor={colors.grey[700]} />
              ) : (
                <ChevronDownIcon size={14} iconColor={colors.grey[700]} />
              )}
            </button>
          </>
        ) : null}
      </Text>
      {summary && isOpen ? <NotificationMessage message={summary} /> : null}
    </div>
  );
};

export default RunEnded;
